module.exports = __webpack_public_path__ + "static/media/robotics480.04fa3bde.mp4";